<template>
  <v-card
    v-bind="$attrs"
    class="base-grid-card"
    :height="height"
    v-on="$listeners"
  >
    <slot/>

    <template v-slot:progress>
      <slot name="progress"/>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "BaseGridCard",

  props: {
    height: {
      type: [String, Number],
      default: "100%",
    },
  },
};
</script>
